<template>
    <modal-component :id="id || 'delete-confirmation'" @close="$emit('close')" :visible="visible">
        <div class="p-3 d-flex align-items-center justify-content-center flex-column">
            <i class="fa fa-3x text-danger" :class="icon || 'fa-trash'"></i>
            <h3 class="font-weight-bold my-4">
                <slot name="title"></slot>
            </h3>
            <p class="text-center mb-5">
                <slot name="description"></slot>
            </p>
            <div class="w-100 d-flex justify-content-between align-items-center">
                <button class="btn" @click="$emit('close')">Cancel</button>
                <button
                    :disabled="disabled"
                    id="confirm-delete-button"
                    class="btn btn-danger font-weight-bold"
                    @click="handleDelete()"
                >
                    {{ buttonText }}
                </button>
            </div>
        </div>
    </modal-component>
</template>

<script>
import ModalComponent from "./ModalComponent";
import { helpers } from "../../plugins/helpers";

export default {
    name: "DeleteConfirmation",
    props: ["id", "icon", "visible", "buttonText", "disabled"],
    components: {
        ModalComponent,
    },
    methods: {
        handleDelete() {
            // Adding a spinner to the button causes the button not to react to any prop changes
            // helpers.toggleSpinner("confirm-delete-button");
            this.$emit("confirm");
        },
    },
};
</script>

<style scoped></style>
